import { authApi } from "./axiosInstance";

const token = () => sessionStorage.getItem("accessToken");
const headers = () => ({ Authorization: `Bearer ${token()}` });

export const getUserTypes = () => authApi.get("/user-types", { headers: headers() });

export const createUserType = (data) => authApi.post("/user-types", data, { headers: headers() });

export const updateUserType = (id, data) => authApi.put(`/user-types/${id}`, data, { headers: headers() });

export const deleteUserType = (id) => authApi.delete(`/user-types/${id}`, { headers: headers() });

export const toggleUserTypeStatus = (id) => authApi.patch(`/user-types/${id}/toggle-status`, null, { headers: headers() });

export const assignUserTypeToUser = (userId, userTypeId) =>
  authApi.patch(`/users/${userId}/user-type`, { userTypeId }, { headers: headers() });

// SYSTEM_ADMIN only — users missing user type or subscription
export const getPendingSetupUsers = () =>
  authApi.get("/users/pending-setup", { headers: headers() });
